<template>
  <div>
    <p class="mb-3">What is the formal charge on the oxygen atom in the molecule shown below?</p>

    <p class="mb-2 pl-3">
      <img :src="$publicAsset('/img/assignments/C2H5O_LS.png')" width="170px" />
    </p>

    <v-form @submit.prevent="submitResponse">
      <v-radio-group v-model="inputs.input1" :disabled="!allowEditing">
        <v-radio
          v-for="option in options"
          :key="option.value"
          class="d-inline-block"
          :value="option.value"
        >
          <template #label>
            <stemble-latex :content="option.text" />
          </template>
        </v-radio>
      </v-radio-group>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex';

export default {
  name: 'Question323',
  components: {StembleLatex},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      // Put a list of inputs or computed properties here to be sent for marking

      inputs: {
        input1: null,
      },
      options: [
        {text: '$-2$', value: '-2'},
        {text: '$-1$', value: '-1'},
        {text: '$0$', value: '0'},
        {text: '$+1$', value: '+1'},
        {text: '$+2$', value: '+2'},
      ],
    };
  },
};
</script>
